export default __webpack_public_path__ + "static/media/annual-dashboard.d9ab56bd.jpg";